import classnames from 'classnames'
import classNames from 'classnames'

import Container from '~/components/atoms/Container/Container'
import DynamicSlider from '~/components/atoms/DynamicSlider'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import type { TeamHighlightCardProps } from '../TeamHighlightCard/TeamHighlightCard'
import TeamHighlightCard from '../TeamHighlightCard/TeamHighlightCard'

import styles from './TeamHighlights.module.css'

export interface TeamHighlightsProps {
  highlights: TeamHighlightCardProps[]
  title?: string | undefined | null
  verticalPadding?: boolean
  reducedHeight?: boolean
}

export default function TeamHighlights({
  highlights,
  title = 'Highlights',
  verticalPadding = false,
  reducedHeight = false,
}: TeamHighlightsProps) {
  const baseThemeClass = ComponentTheme.primary

  return (
    <div
      className={classnames(
        styles.base,
        baseThemeClass && styles[baseThemeClass]
      )}
    >
      <Fixture verticalPadding={verticalPadding} noPaddingBottom>
        <div style={{ overflow: 'hidden' }}>
          <div className={styles.wrap}>
            <Container
              cssClass={classnames(
                styles.sliderContainer,
                reducedHeight && styles.sliderContainerReducedHeight
              )}
            >
              <div className={classNames(styles.slideHead)}>
                {title && (
                  <Text
                    size={TextSizes.primaryTitleLrg}
                    className={styles.slideHeadTitle}
                  >
                    {title}
                  </Text>
                )}
              </div>

              <DynamicSlider
                slidesPerView={1.22}
                slidesPerViewMed={2.1}
                slidesPerViewLrg={3.1}
                slidesPerViewHuge={3.1}
                // spaceBetween={20}
                overflowVisible={true}
                hideTitle={true}
                hideArrows={false}
                hideArrowsMobile={true}
                useScrollbar
                spacer={false}
                wrapperClass={styles.sliderWrapperClass}
              >
                {highlights?.map((item: TeamHighlightCardProps, i: number) => {
                  return (
                    <TeamHighlightCard key={`highlight-item-${i}`} {...item} />
                  )
                })}
              </DynamicSlider>
            </Container>
          </div>
        </div>
      </Fixture>
    </div>
  )
}
